<template>
    <div :class="['tabs-container', customClass ,{fixed:isShowFixedTabs}]">
        <div class="tabs-header" ref="tabHeader">
            <tab-bar ref="tabBar" :items="menus" :value="currentName" :has-ink="hasInk" :ink-length="inkLength" :immediate="immediate" @change="handleTabClick" />
        </div>
        <div class="tabs-body">
            <slot></slot>
        </div>
    </div>
</template>
<script>
    import TabBar from '../TabBar'

    export default {
        name: 'Tabs',
        provide() {
            return {
                rootTabs: this,
            }
        },
        components: {
            [TabBar.name]: TabBar,
        },
        props: {
            value: String,
            hasInk: {
                type: Boolean,
                default: true,
            },
            inkLength: {
                type: Number,
                default: 80,
            },
            isFixedTabs: {
                type: Boolean,
                default: false
            },
            immediate: Boolean,
            customClass: String
        },
        data() {
            return {
                currentName: this.value,
                prevIndex: 0,
                panes: [],
                isShowFixedTabs: false
            }
        },
        computed: {
            menus() {
                return this.panes.map(pane => {
                    return {
                        name: pane.name,
                        label: pane.label,
                        disabled: pane.disabled,
                    };
                })
            },
            currentIndex() {
                for (let i = 0, len = this.menus.length; i < len; i++) {
                    if (this.menus[i].name === this.currentName) {
                        return i;
                    }
                }

                return 0;
            },
        },
        watch: {
            value(val) {
                if (val !== this.currentName) {
                    this.currentName = val;
                    this.$emit('changegetAuth');
                }
            }
        },
        mounted() {
            let { isFixedTabs } = this;
            let offsetObj = null;

            if (!this.currentName && this.menus.length) {
                this.currentName = this.menus[0].name;
            }

            this.$nextTick(() => {
                let { tabHeader } = this.$refs;

                window.addEventListener("scroll", () => {
                    let st = document.documentElement.scrollTop || document.body.scrollTop;

                    if (isFixedTabs) {
                        // 延迟一段时间确保能拿到正确的偏移
                        setTimeout(() => {
                            if (!offsetObj) {
                                offsetObj = this.getOffset(tabHeader);
                            }
                            this.isShowFixedTabs = st >= offsetObj.offsetT;
                        }, 200);
                    }
                }, false);
            });
        },
        methods: {
            getOffset(ele) {
                let offsetT = ele.offsetTop;
                let offsetL = ele.offsetLeft;
                let op = ele.offsetParent;

                while (op != null) {
                    offsetT += op.offsetTop;
                    offsetL += op.offsetLeft;

                    op = op.offsetParent;
                }

                return {
                    offsetT,
                    offsetL
                }
            },
            handleTabClick(tab, index, prevIndex) {
                this.currentName = tab.name;
                this.prevIndex = prevIndex;
                this.$emit('input', tab.name);
                this.$emit('change', tab, index);
            },
            addPane(pane) {
                if (this.panes.indexOf(pane) === -1) {
                    this.panes.push(pane);
                }

            },
            removePane(pane) {
                const index = this.panes.indexOf(pane);

                if (index >= 0) {
                    this.panes.splice(index, 1);
                }
            },
            reflowTabBar() {
                this.$refs.tabBar.reflow();
            }
        }
    }

</script>
<style lang="scss" scoped>
.tabs-container {
    position: relative;
    width: 100%;
    overflow: hidden;

    .tabs-header {
        background-color: #fff;
        border-bottom: 1px solid #e5e5e5;
        margin-bottom: 10px;
        transition: all 0.3s;

    }

    &.fixed {
        .tabs-header {
            position: fixed;
            left: 0;
            width: 100%;
            top: 0;
            z-index: 9999;

        }

        .tabs-body {
            margin-top: 100px;

        }
    }

    .tabs-body {
        position: relative;
    }
}

</style>
